export async function fetchData(id: number) {
  return await fetch(`${(window as any).REACT_APP_CONTENT_API}${id}?v=${+new Date()}`, {
    method: 'GET',
    mode: 'cors'
  });
}
